import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/udi-logo.png'


const _hoisted_1 = { class: "superior" }
const _hoisted_2 = { class: "derecha" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import NotificacionesCampana from '@/components/NotificacionesCampana.vue'
import useAutenticar from '@/store/IngresoAutenticar'


export default /*@__PURE__*/_defineComponent({
  __name: 'BarraSuperior',
  setup(__props) {

/**
 * Barra superior: identidad del usuario, notificaciones y salida.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const route = useRoute()
const auth = useAutenticar()

const titulos: Record<string, string> = {
  Inicio: 'Inicio',
  ListaVersiones: 'Versiones',
  CrearModelo: 'Gestión de Modelos',
  AgregarComponente: 'Agregar Componentes',
  PresentarDocumento: 'Documento del Modelo',
  ModeloCompleto: 'Modelo Completo',
  EstructuraModelo: 'Estructura del Modelo',
  Pesos: 'Gestión de Pesos',
  AgregarIndicadores: 'Indicadores',
  Instrumento: 'Instrumentos',
  FichaDocumental: 'Ficha Documental',
  FichaEstadistica: 'Ficha Estadística',
  FichaOpinion: 'Ficha de Opinión',
  GestionRubricas: 'Gestión de Rúbricas',
  ListaCalificar: 'Calificar Instrumentos',
  InstrumentoDetalle: 'Detalle del Instrumento',
  AsignarRoles: 'Asignar Roles',
  SubirEvidencias: 'Evidencias',
  EvidenciasInstrumentos: 'Evidencias de Instrumentos',
  AsignarEvaluadores: 'Asignar Evaluadores',
  EvaluacionIndividual: 'Evaluación Individual',
  ResultadosConsolidados: 'Resultados Consolidados',
  AuditoriaEvaluaciones: 'Auditoría',
  EvaluacionExpertos: 'Evaluación por Expertos',
  Dashboard: 'Dashboard',
  Calendario: 'Calendario de Acreditación',
  AvanceProceso: 'Avance del Proceso',
  SeguimientoPlan: 'Seguimiento del Plan',
  Trazabilidad: 'Trazabilidad',
  PlanMejoramiento: 'Plan de mejoramiento y fortalecimiento'
}

const titulo = computed(() => {
  const nombre = route.name as string
  return titulos[nombre] ?? 'Modelos'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(titulo.value), 1),
    _createElementVNode("div", _hoisted_2, [
      (_unref(auth).autenticado)
        ? (_openBlock(), _createBlock(NotificacionesCampana, { key: 0 }))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "UDI Logo",
        class: "logo-superior"
      }, null, -1))
    ])
  ]))
}
}

})